import {useAppSelector} from "../../../../../../redux/hooks";
import {getMySongsPageFilterDifficultyMenuTitle} from "../../../../modules/my-songs-page-store/mySongsPage.selectors";

export interface ISongsMobileFilterGroupDifficultyLogic {
  filterLabel: string;
}

export const useSongsMobileFilterGroupDifficultyLogic = (): ISongsMobileFilterGroupDifficultyLogic => {
  const filterLabel = useAppSelector(getMySongsPageFilterDifficultyMenuTitle);
  return {
    filterLabel,
  };
}
